import { Space, Tag, Tooltip } from "antd";
import { FONT } from "constants/index";
import { ArrowRightToLine, UserRoundPen } from "lucide-react";

export const BRANCH_TYPE_STYLES = {
  ESPORTIVO: {
    label: "Centro Esportivo",
    color: "#09ac9c",
    bg: "#e6fffb",
    border: "#87e8de",
  },
  AQUATICO: {
    label: "Centro Aquático",
    color: "#1677ff",
    bg: "#e6f4ff",
    border: "#91caff",
  },
};

export const BranchTypeTag = ({ role }) => {
  const style = BRANCH_TYPE_STYLES[role];
  if (!style) {
    return null;
  }
  return (
    <Tag
      style={{
        fontFamily: FONT,
        color: style.color,
        background: style.bg,
        borderColor: style.border,
        fontWeight: 600,
        margin: 0,
      }}
    >
      {style.label}
    </Tag>
  );
};

export const getBranchRowClassName = (activeBranchId) => (record) => {
  const classes = [];
  const typeClass = {
    ESPORTIVO: "branch-type-esportivo",
    AQUATICO: "branch-type-aquatico",
  }[record.role];
  if (typeClass) {
    classes.push(typeClass);
  }
  if (activeBranchId && record.id === activeBranchId) {
    classes.push("branch-active");
  }
  return classes.join(" ");
};

export const Columns = () => {
  const table = [
    {
      title: "ID",
      dataIndex: "id",
      textWrap: "word-break",
      ellipsis: true,
      width: "10%",
    },
    {
      title: "Nome",
      dataIndex: "name",
      textWrap: "word-break",
      ellipsis: true,
      width: "20%",
      render: (text, row) => (
        <div>
          <div>{text}</div>
          <div
            className="card-profile-meta"
            style={{ fontFamily: FONT, fontSize: 12, color: "#8c8c8c" }}
          >
            ID: {row.id}
          </div>
        </div>
      ),
    },
    {
      title: "Administrador",
      dataIndex: "email",
      textWrap: "word-break",
      ellipsis: true,
      width: "20%",
    },
    {
      title: "Tipo",
      dataIndex: "profile",
      width: "15%",
      render: (text, row) => <BranchTypeTag role={row.role} />,
    },
  ];

  table.push({
    title: "Ações",
    dataIndex: "action",
    width: "15%",
    render: (text, row) => {
      return (
        <Space size="middle">
          <Tooltip style={{ fontFamily: FONT }} title="Editar Unidade">
            <UserRoundPen
              onClick={() => row.edit(row)}
              size={22}
              style={{ cursor: "pointer", color: "#09ac9c" }}
            />
          </Tooltip>
          <Tooltip style={{ fontFamily: FONT }} title="Acessar Unidade">
            <ArrowRightToLine
              onClick={() => row.changeBranch(row)}
              size={22}
              style={{ cursor: "pointer", color: "#1677ff" }}
            />
          </Tooltip>
        </Space>
      );
    },
  });
  return table;
};
